import { render, staticRenderFns } from "./StaffDetailsView.vue?vue&type=template&id=32a64515&scoped=true"
import script from "./StaffDetailsView.vue?vue&type=script&lang=js"
export * from "./StaffDetailsView.vue?vue&type=script&lang=js"
import style0 from "./StaffDetailsView.vue?vue&type=style&index=0&id=32a64515&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a64515",
  null
  
)

export default component.exports